export default __webpack_public_path__ + "static/media/DNo.11-2.661cfd30.jpg";